/**
 * Validates the format of an email address.
 *
 * @param {string} email - The email address to validate.
 * @returns {boolean} - Returns true if the email format is invalid, false otherwise.
 */
export const isEmailValid = (email) => {
  // Check if the email format is valid using a regular expression. If the email does not match the pattern, it is considered invalid.
    return (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email));

};
/**
 * Validates the email against the disallowed domains.
 *
 * @param {string} email - The email address to validate.
 * @returns {boolean} - Returns true if the email format is invalid, false otherwise.
 */
export const isEmailDomainAllowed = (email) => {
 // Test the email against the disallowed domains
 const disallowedDomainsRegex = /@(gmail|yahoo|icloud|hotmail|outlook|msn|mee|aol)\.com$/i;
 return !disallowedDomainsRegex.test(email);
};